import theme from 'src/utils/theme';
import { ButtonState } from '.';

export interface AudioResponseButtonColors {
  buttonBackground: string;
  border: string;
  font: string;
  numberBackground: string;
}

export const selectedColors: AudioResponseButtonColors = {
  buttonBackground: theme.co.primary20,
  border: theme.co.primary20,
  font: theme.co.primary20,
  numberBackground: theme.co.neutral99,
};

export const selectedPlayingColors: AudioResponseButtonColors = {
  buttonBackground: 'none',
  border: theme.co.primary20,
  font: theme.co.primary20,
  numberBackground: theme.co.neutral99,
};

export const correctColors: AudioResponseButtonColors = {
  buttonBackground: theme.co.success80,
  border: theme.co.success40,
  font: theme.co.success40,
  numberBackground: theme.co.neutral99,
};

export const incorrectColors: AudioResponseButtonColors = {
  buttonBackground: theme.co.error80,
  border: theme.co.error40,
  font: theme.co.error40,
  numberBackground: theme.co.neutral99,
};

export const defaultColors: AudioResponseButtonColors = {
  buttonBackground: 'none',
  border: theme.co.secondary80,
  font: theme.co.neutral99,
  numberBackground: theme.co.neutral20,
};

export const getColors = (
  buttonState: ButtonState,
  playing: boolean,
): AudioResponseButtonColors => {
  switch (buttonState) {
    case 'default':
      return defaultColors;
    case 'yellow': {
      return playing ? selectedPlayingColors : selectedColors;
    }
    case 'green':
      return correctColors;
    case 'red':
      return incorrectColors;
  }
};
